// Style files
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/sass/styles.scss";
import "v-calendar/style.css";
import "vue-advanced-cropper/dist/style.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";
/* import specific icons */
import {
  faUserSecret,
  faDoorOpen,
  faSignInAlt,
  faMugHot,
  faStethoscope,
  faChild,
  faPeopleRoof,
  faCircleQuestion,
  faArrowsRotate,
  faTrash,
  faSearch,
  faStar,
  faEllipsisV,
  faUndo,
  faThumbtack,
  faThermometerFull,
  faThermometerHalf,
  faThermometerEmpty,
  faBars,
  faFilter,
  faCircle,
  faPlus,
  faTimes,
  faTimesCircle,
  faCaretUp,
  faUser,
  faUsers,
  faUserFriends,
  faUserTie,
  faList,
  faShieldAlt,
  faPen,
  faKey,
  faCheckCircle,
  faExclamationCircle,
  faClone,
  faDownload,
  faChevronLeft,
  faCalendarAlt,
  faBullseye,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(
  faUserSecret,
  faDoorOpen,
  faSignInAlt,
  faMugHot,
  faStethoscope,
  faChild,
  faPeopleRoof,
  faCircleQuestion,
  faArrowsRotate,
  faTrash,
  faSearch,
  faStar,
  faEllipsisV,
  faUndo,
  faThumbtack,
  faThermometerFull,
  faThermometerHalf,
  faThermometerEmpty,
  faBars,
  faFilter,
  faCircle,
  faPlus,
  faTimes,
  faTimesCircle,
  faCaretUp,
  faUser,
  faUsers,
  faUserFriends,
  faUserTie,
  faList,
  faShieldAlt,
  faPen,
  faKey,
  faCheckCircle,
  faExclamationCircle,
  faClone,
  faDownload,
  faChevronLeft,
  faCalendarAlt,
  faBullseye,
  faInfoCircle,
);
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "@/app/router/router";
import ElementPlus from "element-plus";
import VCalendar from "v-calendar";
import es from "element-plus/dist/locale/es.mjs";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import AccentInsensitiveSelectPlugin from "@/utils/plugins/AccentInsensitiveSelectPlugin";
import mitt from "mitt";
import dayjs from "dayjs";
// import {utc} from "moment";
const emitter = mitt();
const pinia = createPinia();

const appInstance = createApp(App);
appInstance.use(pinia);
appInstance.use(router);
appInstance.provide("emitter", emitter);
appInstance.use(VCalendar, {});

dayjs.locale("es");
// set first day of week to Monday
// dayjs.Ls.en.weekStart = 1
dayjs.Ls.es ??= {};
dayjs.Ls.es.weekStart = 1;
// dayjs.weekStart = 1
let utc = require("dayjs/plugin/utc");
let timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

appInstance.use(ElementPlus, {
  locale: es,
});
appInstance.use(AccentInsensitiveSelectPlugin);
appInstance.component("font-awesome-icon", FontAwesomeIcon);
appInstance.component("font-awesome-layers", FontAwesomeLayers);
appInstance.component("font-awesome-layer-texts", FontAwesomeLayersText);
appInstance.component("QuillEditor", QuillEditor);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  appInstance.component(key, component);
}

// Esperar a que el router resuelva la navegación inicial antes de montar: si no,
// en una carga en frío App.vue puede montarse (y disparar su onMounted) antes de
// que `route.name` refleje la ruta real de la URL, con el valor todavía
// indefinido — lo que rompe cualquier lógica que decida según la ruta actual al
// arrancar (ej. no forzar logout en rutas públicas como confirm-password-reset).
router.isReady().then(() => {
  appInstance.mount("#app");
});
